export default class MetricPoints {

    public index?: number = undefined;
    public name?: string = undefined;
    public points?: number = undefined;

    public assign(response: any): MetricPoints {
        if (response) {
            for (const key in response) {
                if (response.hasOwnProperty(key) && this.hasOwnProperty(key)) {
                    (this as any)[key] = response[key];
                }
            }
        }

        return this;
    }
}
